import React, { useContext, useEffect, useState } from "react";
import { Spinner, Table } from "reactstrap";
import Select from "react-select";
import { materialOptions, updateMaterialForOption } from "./service";
import { CustomizationSpinnerContainer, Notification } from "../common/style";
import { AppContext } from "../context";
import { useParams } from "react-router-dom";

const Materials = ({ currentRoom, loadRoom, finalisedContexts }) => {
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const { projectInfo: project } = useContext(AppContext);
  const [materialsData, setMaterialsData] = useState({});
  const [selectedMaterials, setSelectedMaterials] = useState({});
  const [reloadTable, setReloadTable] = useState(true);
  const params = useParams();
  const projectId = params.projectId;

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const loadMaterialsData = () => {
    setIsLoading(true);
    materialOptions({ projectId: projectId, category: "board" })
      .then((response) => {
        project.materialOptionsData = response;

        if (reloadTable) {
          setMaterialsData(response);
          setSelectedMaterials(
            getSelectedMaterials(project.materialOptionsData.material_options)
          );
        }

        setReloadTable(false);
      })
      .catch((error) => {
        setNotification({ message: error.error, type: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getMaterialOption = (materialIdentifier, index) => {
    if (materialIdentifier === null) {
      return null;
    }
    const material = materialsData.materials["board"].find(
      (material) => material.identifier === materialIdentifier
    );
    if (!material) {
      return null;
    }
    return {
      name: material.name,
      label: material.name,
      value: material.identifier,
    };
  };

  const handleMaterialChange = ({ optionIdentifier, materialIdentifier }) => {
    setIsLoading(true);
    updateMaterialForOption({
      projectId: projectId,
      optionIdentifier: optionIdentifier,
      materialIdentifier: materialIdentifier,
      materialCategory: "board",
    })
      .then((response) => {
        setNotification({
          message: "Materials Updated",
          type: "success",
        });
        selectedMaterials[optionIdentifier] = materialIdentifier;
        loadRoom(currentRoom.id);
      })
      .catch(({ error }) => {
        setNotification({ message: error, type: "error" });
      })
      .finally(() => {
        setIsNotificationVisible(true);
        setIsLoading(false);
      });
  };

  const getSelectedMaterials = (materialOptionsData) => {
    let selectedMaterials = {};
    Object.entries(materialOptionsData).forEach(
      ([optionIdentifier, materialOption]) => {
        selectedMaterials[optionIdentifier] = materialOption.identifier;
      }
    );
    return selectedMaterials;
  };

  useEffect(() => {
    loadMaterialsData();
  }, []);

  return (
    <>
      {notification.type && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notification.message}
        </Notification>
      )}

      {
        <div
          className={`${isLoading ? "blurred" : ""}`}
          style={{
            minWidth: "350px",
          }}
        >
          <div>
            {isLoading && (
              <CustomizationSpinnerContainer>
                <Spinner />
              </CustomizationSpinnerContainer>
            )}
          </div>

          <div className="p-3">
            <Table bordered hover striped>
              <thead>
                <tr>
                  <th>Option</th>
                  <th>Material</th>
                </tr>
              </thead>

              <tbody className="align-middle">
                {materialsData.material_options &&
                  Object.entries(materialsData.material_options)
                    .filter(
                      ([optionIdentifier, materialOption]) =>
                        materialOption.identifier
                    )
                    .map(([optionIdentifier, materialOption], index) => {
                      const isShutterProperty =
                        optionIdentifier.includes("shutter");
                      const disabled =
                        (finalisedContexts.includes("shutter") &&
                          isShutterProperty) ||
                        (finalisedContexts.includes("carcass") &&
                          !isShutterProperty);

                      return (
                        <tr key={index}>
                          <td className="w-25">{materialOption.label}</td>
                          <td className="w-75">
                            <Select
                              isDisabled={disabled}
                              value={getMaterialOption(
                                selectedMaterials[optionIdentifier]
                              )}
                              className="mt-2"
                              options={materialsData.materials["board"].map(
                                (materialOptionObj) => ({
                                  name: materialOptionObj.name,
                                  label: materialOptionObj.name,
                                  value: materialOptionObj.identifier,
                                })
                              )}
                              onChange={(selectedMaterial) => {
                                handleMaterialChange({
                                  optionIdentifier: optionIdentifier,
                                  materialIdentifier: selectedMaterial.value,
                                });
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}

                {materialsData.material_options &&
                  Object.entries(materialsData.material_options)
                    .filter(
                      ([optionIdentifier, materialOption]) =>
                        !materialOption.used && !materialOption.identifier
                    )
                    .map(([optionIdentifier, materialOption], index) => {
                      const isShutterProperty =
                        optionIdentifier.includes("shutter");
                      const disabled =
                        (finalisedContexts.includes("shutter") &&
                          isShutterProperty) ||
                        (finalisedContexts.includes("carcass") &&
                          !isShutterProperty);
                      return (
                        <tr key={index}>
                          <td className="w-25">{materialOption.label}</td>
                          <td className="w-75">
                            <Select
                              isDisabled={disabled}
                              value={getMaterialOption(
                                selectedMaterials[optionIdentifier]
                              )}
                              className="mt-2"
                              options={materialsData.materials["board"].map(
                                (materialOptionObj) => ({
                                  name: materialOptionObj.name,
                                  label: materialOptionObj.name,
                                  value: materialOptionObj.identifier,
                                })
                              )}
                              onChange={(selectedMaterial) => {
                                handleMaterialChange({
                                  optionIdentifier: optionIdentifier,
                                  materialIdentifier: selectedMaterial.value,
                                });
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </Table>
          </div>
        </div>
      }
    </>
  );
};

export default Materials;
